export enum StakingLocators {
	sourceStakeAccountAddressField = 'sourceStakeAccountAddressField',
	currencyField = 'currencyField',
	noteField = 'noteField',
	stakingCreatedAtField = 'stakingCreatedAtField',
	stakingCreatedAtRefreshIcon = 'stakingCreatedAtRefreshIcon',
	stakingMergeButton = 'stakingMergeButton',
}
